module.exports = __webpack_public_path__ + "img/menu-close.cd29c8cd.svg";